<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Check in — booking #{{ data.requisitionId }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>
  <span class="dialog-sub">{{ data.name }} · Family {{ data.familyCode }}</span>

  @if(guests.length){
  <div class="allotment">
    <span class="field-label">Guests — room and verification</span>
    <table class="allotment-table">
      <thead>
        <tr><th>Guest</th><th>Room</th><th>Verified</th></tr>
      </thead>
      <tbody>
        @for(g of guests; track guestKey(g)){
        <tr>
          <td>{{ g.name || '-' }}</td>
          <td>
            @if(rooms.length){
            <select class="text-box-active room-select" [(ngModel)]="g.roomCatalogueInstanceId">
              <option value="">Not noted</option>
              @for(r of rooms; track r.roomCatalogueInstanceId){
              <option [value]="r.roomCatalogueInstanceId">{{ r.roomCode }} ({{ r.guestHouse }})</option>
              }
            </select>
            } @else { <span class="muted">-</span> }
          </td>
          <td class="verify-cell">
            @if(canVerify(g)){
            <input type="checkbox" [(ngModel)]="g.isPhysicalVerified" />
            } @else { <span class="muted">-</span> }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  <form [formGroup]="form" class="dialog-form">
    <label class="checkbox-row">
      <input type="checkbox" formControlName="inRegisterSigned" />
      <span>In-register signed</span>
    </label>

    <div class="field">
      <span class="field-label">Key handed over by</span>
      <input type="text" class="text-box-active" formControlName="keyHandedOverUser" />
    </div>

    <div class="field">
      <span class="field-label">In-register signed by</span>
      <input type="text" class="text-box-active" formControlName="inRegSignedUser" />
    </div>

    <div class="field">
      <span class="field-label">Comments</span>
      <textarea class="text-box-active" rows="3" formControlName="checkinComments"></textarea>
    </div>

    <label class="checkbox-row acceptance">
      <input type="checkbox" formControlName="finalCheck" />
      <span>
        I have verified the Aarghya Praswasti and Govt. ID of the primary requestor
        and the associated devotees and visitors and found them satisfactory.
      </span>
    </label>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" [disabled]="!form.value.finalCheck" (click)="submit()">Check in</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
